/* eslint quote-props: "off" */
import React from 'react';
import { useAuth } from 'react-oidc-context';

import CenterLoadingSpinner from '../../components/LoadingSpinner/CenterLoadingSpinner';

interface EmbedParams {
  [name: string]: string | undefined;
  readonly site: string;
}

const EmbedForUrl = (url: string) => {
  const Embed: React.FC = () => {
    const auth = useAuth();

    if (auth.user == null) {
      return <CenterLoadingSpinner />;
    }

    const pageUrl = url.replaceAll('{portalToken}', auth.user.access_token).replace('{middleAuth}', import.meta.env.VITE_MA_URL);

    return <iframe src={pageUrl} className='w-screen lg:w-[calc(100vw-320px)] -h-screen-nav' />;
  };
  return <Embed />;
};

export default EmbedForUrl;
